import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { authApi } from './services/authApi'
import { productApi } from './services/productApi'
import { categoryApi } from './services/categoryApi'
import { catalogueApi } from './services/catalogueApi'
import { collectionApi } from './services/collectionApi'
import { customerApi } from './services/customerApi'
import { inventoryApi } from './services/inventoryApi'
import authReducer from './slices/authSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [catalogueApi.reducerPath]: catalogueApi.reducer,
    [collectionApi.reducerPath]: collectionApi.reducer,
    [customerApi.reducerPath]: customerApi.reducer,
    [inventoryApi.reducerPath]: inventoryApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      productApi.middleware,
      categoryApi.middleware,
      catalogueApi.middleware,
      collectionApi.middleware,
      customerApi.middleware,
      inventoryApi.middleware
    ),
})

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
